const linksEnum = {
  BUSCA_CEP: "https://buscacepinter.correios.com.br/app/endereco/index.php"
}

export default linksEnum
